/* eslint-disable react/prop-types */
import Moveable, { DIRECTIONS} from "react-moveable";

function DraggAbleComponentView({data}) {
    // console.log(data)
  return (
    <div>
        <div id={data?.id} className="w-[200px] h-[200px] absolute flex items-center justify-center" style={data?.style} >
            <div className=" text-2xl -mt-10">
            {data?.name} {(data?.isMerged)&& "["+data?.mergedName+"]"}
            </div>
        </div>
        {/* <Moveable
            target={``}
            draggable={true}
            roundable={true}
            rotatable={{
                        renderDirections: DIRECTIONS,
                    }}
            resolveAblesWithRotatable={{
                resizable: ["nw", "ne", "sw", "se", "n", "e", "s"],
            }}
            resizable={{
                renderDirections: true,
            }}

            rotateAroundControls={true}
            isDisplayShadowRoundControls={"horizontal"}
            roundClickable={"control"}
            roundPadding={15}
            onRender={e => {
                e.target.style.cssText += e.cssText;
            }}
            onRenderEnd={e => {
                e.target.style.cssText += e.cssText;
            }}
        /> */}
    </div>
  );
}

export default DraggAbleComponentView;